import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { ToastService } from 'src/app/core/toast.service';
import { ApiFreteService } from 'src/app/dao/api-frete.service';
import { UnidadeApiService } from 'src/app/dao/api_unidade.service';
import { Frete } from 'src/app/model/frete';
import { RangeKm } from 'src/app/model/rangekm';
import { Unidade } from 'src/app/model/unidade';

@Component({
  selector: 'app-fretekm',
  templateUrl: './fretekm.page.html',
  styleUrls: ['./fretekm.page.scss'],
  providers: [MessageService, ConfirmationService]
})
export class FretekmPage implements OnInit {
  


  freteDialog: boolean;

  fretes: RangeKm[];

  frete: RangeKm;

  selectedfretes: RangeKm[];

  submitted: boolean;

  ativos;
//parte antiga

  unidade: Unidade;

  jsonFrete: string;
  
  products1: RangeKm[];

  products2: RangeKm[];

  statuses: SelectItem[];

  idCategoria;

  resultadoBuscaKm: string;

  clonedProducts: { [s: string]: RangeKm; } = {};

  constructor(private apiUnidade: UnidadeApiService, private route: ActivatedRoute, private freteService: ApiFreteService, private toast: ToastService, private confirmationService: ConfirmationService) { }

    async ngOnInit() {
    this.unidade = new Unidade();
    this.frete = new RangeKm();
    await this.loadUnidade();
    this.fretes = JSON.parse(this.resultadoBuscaKm);
    
    
    
    
  }

    async ionViewWillEnter() {
    this.unidade = new Unidade();
    this.frete = new RangeKm();
    await this.loadUnidade();
    this.fretes = JSON.parse(this.resultadoBuscaKm);
    
    
    
    
  }

  async loadUnidade() {
    this.unidade = await this.apiUnidade.getAtual();
    this.jsonFrete = this.unidade.ranges_frete_km;
    console.log(this.jsonFrete);
    if(this.jsonFrete.length < 1 || this.jsonFrete == "" || this.jsonFrete == "null" || this.jsonFrete == null){
      this.jsonFrete = '[{"id":1,"kmini":0,"kmfim":5,"valor":2, "frase":""}]';
    }
    this.resultadoBuscaKm = this.jsonFrete;

  }

  carregarAtivos() {
    this.ativos = this.ativos.map(c => {
      return ({ label: c.nome, value: c.valor });
      // tslint:disable-next-line: align
    });
}

openNew() {
// tslint:disable-next-line: new-parens
this.frete = {};
this.submitted = false;
this.freteDialog = true;
}

deleteSelectedfretes() {
this.confirmationService.confirm({
  message: 'Deseja mesmo deletar todos os intervalos de KM?',
  header: 'Confirmar',
  acceptLabel: 'Sim',
  rejectLabel: 'Não',
  icon: 'pi pi-exclamation-triangle',
  accept: () => {
    this.fretes = [];
    this.unidade.ranges_frete_km = "[]";
    this.apiUnidade.atualizarRangesKm(this.unidade);
    this.toast.showSucess('Intervalos Excluídos com Sucesso!');
  }
});
}


deletefrete(frete: RangeKm) {
this.confirmationService.confirm({
  message: 'Deseja mesmo deletar o frete?',
  header: 'Confirmar',
  acceptLabel: 'Sim',
  rejectLabel: 'Não',
  icon: 'pi pi-exclamation-triangle',
  accept: () => {
    console.log(frete.id);
    console.log(this.fretes.length);
    if(frete.id === this.fretes.length){
    //const result = this.freteService.excluir(frete.id);
    this.fretes = this.fretes.filter(val => val.id !== frete.id);
    this.frete = {};
    this.unidade.ranges_frete_km = JSON.stringify(this.fretes);
    this.apiUnidade.atualizarRangesKm(this.unidade);
    this.toast.showSucess('Intervalo Excluído com Sucesso!');
    }else{
      this.toast.showError('Só é possível apagar o último item da lista (ordem decresente)');
    }
  }
});
}

hideDialog() {
this.freteDialog = false;
this.submitted = false;
}

async savefrete() {
this.submitted = true;
if(this.fretes.length < 1){
  this.frete.id = 1;
  this.frete.kmini = 0;
  if(this.frete.valor == null || this.frete.valor == undefined || this.frete.valor < 0){
    this.frete.valor = 0;
  }
  this.fretes.push(this.frete);
  this.toast.showSucess('Intervalos Cadastrado com Sucesso!');
  this.unidade.ranges_frete_km = JSON.stringify(this.fretes);
  this.apiUnidade.atualizarRangesKm(this.unidade);
}else{

  var ultimoRegistro = this.fretes[this.fretes.length-1];

  if(this.frete.kmfim <= ultimoRegistro.kmfim){
    this.toast.showError("O valor de KM do registro deve ser maior do que o do último da lista!")
  }else{
  this.frete.id = this.fretes.length+1;
  this.frete.kmini = ultimoRegistro.kmfim;
  if(this.frete.valor == null || this.frete.valor == undefined || this.frete.valor < 0){
    this.frete.valor = 0;
  }
  this.fretes.push(this.frete);
  this.toast.showSucess('Frete Cadastrado com Sucesso!');
  this.unidade.ranges_frete_km = JSON.stringify(this.fretes);
  this.apiUnidade.atualizarRangesKm(this.unidade);
  }

}
  console.log(this.fretes);
  this.fretes = [...this.fretes];
  this.freteDialog = false;
  this.frete = {};
  console.log(this.fretes);
}



mudastts(){
  console.log(this.unidade.exibir_frasekm_cupom);
  console.log(this.unidade.exibir_frasekm_tela);
  console.log(this.unidade);
  this.apiUnidade.atualizarRangesKm(this.unidade);
}



findIndexById(id: number): number {
let index = -1;
for (let i = 0; i < this.fretes.length; i++) {
  // tslint:disable-next-line: radix
  if (this.fretes[i].id === id) {
    index = i;
    break;
  }
}

return index;
}
}


